import React from 'react';
import * as CSS from 'csstype';
import { colors } from '../../settings';
import { Box } from '../Box';

type IconComponent = React.ComponentType<{ color: CSS.Property.Color | colors.Color }>;

export function Prefix({
    children,
    icon: Icon,
}: {
    children?: React.ReactNode;
    icon?: IconComponent;
}) {
    return (
        <Box display="flex" alignItems="center" marginRight="quarterGutter">
            {Icon && <Icon color={colors.fiftyFirstShade} />}
            {children}
        </Box>
    );
}
